import { Component } from '@angular/core'
import { IonicPage, NavController, NavParams } from 'ionic-angular'

import { CallsPage } from '../calls/calls'
import { ContactListPage } from '../contact-list/contact-list'
import { ContractsListPage } from '../contracts-list/contracts-list'
import { MeetingListPage } from '../meeting-list/meeting-list'
import { ShortcutsPage } from '../shortcuts/shortcuts'

@IonicPage()
@Component({
  selector: 'page-main',
  templateUrl: 'main.html',
})
export class MainPage {

  mainPage: any;

  callsPage = CallsPage;
  meetingListPage = MeetingListPage;
  contactListPage = ContactListPage;
  contractsListPage = ContractsListPage;
  shortcutsPage = ShortcutsPage

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }
}



// WEBPACK FOOTER //
// ./src/pages/main/main.ts